import { useState } from 'react';
import type { AppView } from '../api/client';

interface DangerZoneProps {
  app: AppView;
  /** True when this row is the console's own app client. */
  isSelf: boolean;
  busy: boolean;
  onDelete: (confirm: string) => void;
}

export function DangerZone({ app, isSelf, busy, onDelete }: DangerZoneProps) {
  const [typed, setTyped] = useState('');

  if (isSelf) {
    // The server refuses this too - the guard is not the disabled button. This explains why, and
    // names the escape hatch, because the CLI genuinely can do it.
    return (
      <section className="danger">
        <h2>Danger zone</h2>
        <div className="callout">
          This is the admin console&rsquo;s own app client. Deleting it here would lock everyone out
          of this UI, so it is refused. To remove it anyway, from a workstation with AWS
          credentials:
          <pre>npm run broker -- app:remove {app.app_name}</pre>
        </div>
      </section>
    );
  }

  return (
    <section className="danger">
      <h2>Danger zone</h2>
      <p>
        Deleting <strong>{app.app_name}</strong> removes its Cognito app client and its registry
        row. Anyone signed in to it stays signed in until their token expires, and the app cannot
        obtain new ones. This cannot be undone - <strong>disabling</strong> is the reversible
        option.
      </p>
      <label className="field">
        <span>
          Type <code>{app.app_name}</code> to confirm
        </span>
        <input
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          disabled={busy}
          autoComplete="off"
        />
      </label>
      <button
        type="button"
        className="destructive"
        disabled={busy || typed.trim() !== app.app_name}
        onClick={() => onDelete(typed.trim())}
      >
        {busy ? 'Deleting…' : `Delete ${app.app_name}`}
      </button>
    </section>
  );
}
